export default __webpack_public_path__ + "static/media/rocket_anim_9.982b1f5b.png";